import { faCheck, faQuestion, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import styled from 'styled-components';

import { colorScheme } from '../../../theme';

interface Props {
  thumbState: string;
  onClick: (evt: any) => void;
  'data-accesskey'?: string;
}

export function StateSwitcherButton(props: Props) {
  const { thumbState, ...passthroughProps } = props;

  let icon = faQuestion;

  if (thumbState === 'approved') {
    icon = faCheck
  } else if (thumbState === 'rejected') {
    icon = faXmark;
  }

  return (
    <ClickableArea {...passthroughProps}>
      <CircleWrapper >
        <FontAwesomeIcon
          icon={icon}
          className="fa-flag"
          title="Toggle state"
          size="xs"
        />
      </CircleWrapper>
    </ClickableArea>
  );
}

const CircleWrapper = styled.div`
  border-radius: 100%;
  color: ${colorScheme.brand};
  background: #e4e9fb;
  cursor: pointer;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 16px solid transparent;
  z-index: 10;
`;

const ClickableArea = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  padding-top: 8px;
  padding-left: 8px;
  padding-bottom: 12px;
  padding-right: 12px;
  cursor: pointer;
  z-index: 2;
`;
